export const sxStyles = {
  radioLabel: {
    position: 'relative',
  },
};
